import React from 'react';
import { CONTENTSTACK, ENVIRONMENT, URLS } from '../../../constants';
import { useDebug } from './debug-provider';
import DebugPill from './debug-pill';

const EnvironmentDebug = (): JSX.Element | null => {
    const { showEnvironmentInfo } = useDebug();

    if (!showEnvironmentInfo) {
        return null;
    }

    const netlify = ENVIRONMENT.IS_RUNNING_ON_NETLIFY ? 'on' : 'off';
    const csEnv = CONTENTSTACK.SERVER_SIDE.CONTENTSTACK_ENVIRONMENT || '—';
    // eslint-disable-next-line no-restricted-syntax -- Report the bundler's literal NODE_ENV value.
    const nodeEnv = process.env.NODE_ENV || '—';
    const oneLiner = `Netlify: ${netlify} · CS: ${csEnv} · Node: ${nodeEnv}`;
    const title = [
        `Netlify (build): ${netlify}`,
        `Contentstack env: ${csEnv}`,
        `NODE_ENV: ${nodeEnv}`,
        `IS_DRAFTS: ${ENVIRONMENT.IS_DRAFTS}`,
        `IS_SERVPRO_COM_TRUE_PRODUCTION: ${ENVIRONMENT.IS_SERVPRO_COM_TRUE_PRODUCTION}`,
        `IS_DEV: ${ENVIRONMENT.IS_DEV}`,
        `IS_NOT_DEV: ${ENVIRONMENT.IS_NOT_DEV}`,
        `CANONICAL_URL: ${URLS.CLIENT_SIDE.CANONICAL_URL || '—'}`,
    ].join('\n');

    return (
        <DebugPill title={title}>
            {oneLiner}
        </DebugPill>
    );
};

export default EnvironmentDebug;
